import React from 'react';
import styled, { keyframes } from 'styled-components';
import { burnishedSilver } from 'web-ui-kit/colors';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2;

function SkeletonLoader(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return (
    /*#__PURE__*/
    React.createElement(Rectangle, {
      "data-testid": "rectangle",
      "aria-busy": true,
      "aria-live": "polite",
      className: className,
      role: "alert"
    }, children)
  );
}

var shimmer = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  0% { opacity: 0.6; }\n  100% { opacity: 0.3; }\n"])));
var Rectangle = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  /**\n   * client should explictly override height and/or width OR place\n   * skeleton into a container with explicit height and width.\n   */\n  height: 100%;\n  width: 100%;\n\n  animation: ", " 1s infinite alternate;\n  background-color: ", ";\n  opacity: 0.6;\n"])), shimmer, burnishedSilver);
export default SkeletonLoader;